<div *ngIf="showSpinner" class="fixed inset-0 flex items-center justify-center bg-white bg-opacity-80 z-50" role="alert"
  aria-live="assertive" aria-label="Loading">
  <div class="relative flex items-center justify-center w-32 h-32">
    <img src="assets/svg/logo.svg" alt="" role="presentation" aria-hidden="true"  class=" w-16 h-16 animate-spin" />
  </div>
</div>